import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import back_n from "../Tutorials/Image/back_n.gif";
import back_o from "../Tutorials/Image/back_o.gif";
import back_d from "../Tutorials/Image/back_d.gif";
import principle_n from "../Tutorials/Image/principle_n.gif";
import tutorials_n from "../Tutorials/Image/tutorials_n.gif";
import clue_n from "../Tutorials/Image/clue_n.gif";
import solution_n from "../Tutorials/Image/solution_n.gif";
import solution_o from "../Tutorials/Image/solution_o.gif";
import solution_d from "../Tutorials/Image/solution_d.gif";
import next_n from "../Tutorials/Image/next_n.gif";
import next_o from "../Tutorials/Image/next_o.gif";
import next_d from "../Tutorials/Image/next_d.gif";
import ok_n from "../Tutorials/Image/ok_n.gif";
import ok_o from "../Tutorials/Image/ok_o.gif";
import ok_d from "../Tutorials/Image/ok_d.gif";
import done_o from "../Tutorials/Image/done_o.gif";
import done_n from "../Tutorials/Image/done_n.gif";
import x_close_btn_n from "../Tutorials/Image/x_close_btn_n.png";
import x_close_btn_o from "../Tutorials/Image/x_close_btn_o.png";
import next_step_btn_n from "../Tutorials/Image/next_step_btn_n.png";
import next_step_btn_o from "../Tutorials/Image/next_step_btn_o.png";
import got_it_btn_n from "../Tutorials/Image/got_it_btn_n.png";
import got_it_btn_o from "../Tutorials/Image/got_it_btn_o.png";
import './Style/Question.css';
import Loading from "../../Common/Loading";
import { buildNextQuestionData, buildShuffledQuestionsOrder, saveQuestionPerformance, QuestionPerformancePayload } from '../../services/questionApi';
import { useViewLessonPreview } from './hooks/useViewLessonPreview';
export interface AnswerRef {
    getAnswer: () => {
        marks: number;
        noOfOptions: number;
        enteredCorrectAnswer: string;
        enteredWrongAnswer: string;
        enteredBlankAnswer: string;
        scoringMethod?: number | null;
        optOrder?: string;
    } | null;
}

const lQnsStyles = `
    .l-qns-container {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding-top: 20px;
        height: 100%; 
        width: 100%;
        overflow: auto;
        background-color: #f8fafc;
    }
    .l-qns-main {
        flex: 1;
        display: flex;
        justify-content: center;
    }
    .l-qns-main table[name="TableQn"] {
        margin: 0 auto;
    }
    .l-qns-main table, .l-qns-main tr, .l-qns-main td {
        background-color: transparent !important;
        text-align: center;
    }
    .l-qns-main table[name="TableQn"] * {
        margin-left: auto !important;
        margin-right: auto !important;
        text-align: center !important;
    }
    .l-qns-divider {
        width: 10px;
        height: 80vh;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .l-qns-options-panel {
        width: 310px;
        padding: 0 10px;
        font-family: arial;
    }
    .l-qns-options-header {
        font-size: 20pt;
        color: #3c5168;
        padding-bottom: 10px;
    }
    .l-qns-option-item {
        height: 50px;
        margin-top: 10px;
        padding-left: 5px;
        font-size: 20px;
        font-family: 'Arial';
        color: black;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border: none;
    }
    .feedback-box {
        width: 40px;
        height: 40px;
        border: none;
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
    }
    .item-text {
        flex-grow: 1;
        text-align: center;
        padding-right: 55px;
    }
`;

interface LQnsProps {
    lessonMeta?: any;
    questionHtml: string;
    currentPage: number;
    totalPages: number;
    goToNextPage?: (e: React.MouseEvent) => void;
    showAlert: (message: string) => void;
    correctAudio: string[];
    incorrectAudio: string[];
    assetsBaseUrl?: string;
    sessionId: number | null;
    isCompleting?: boolean;
    updateSessionPoints?: (pointsEarned: number) => void;
    hwid?: number | null;
    subject?: string;
    previewMode?: string | null;
}

const LQns: React.ForwardRefRenderFunction<AnswerRef, LQnsProps> = (props, ref) => {

    const { lessonMeta, questionHtml, currentPage, totalPages, goToNextPage, correctAudio, incorrectAudio, assetsBaseUrl, showAlert, sessionId, isCompleting, updateSessionPoints, hwid, subject, previewMode } = props;
    const navigate = useNavigate();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const folderParam = params.get('folder');
    const lessonName = params.get('name');
    const diccode = params.get('diccode');
    const calledFrom = params.get('calledFrom');
    const solnIframeRef = useRef<HTMLIFrameElement>(null);
    const clueIframeRef = useRef<HTMLIFrameElement>(null);
    const prcIframeRef = useRef<HTMLIFrameElement>(null);

    const [backSrc, setBackSrc] = useState(back_n);
    const [nextSrc, setNextSrc] = useState(next_n);
    const [okSrc, setOkSrc] = useState(ok_n);
    const [doneSrc, setDoneSrc] = useState(done_n);
    const [okClicked, setOkClicked] = useState(false);
    const [currentQnMeta, setCurrentQnMeta] = useState<any | null>(null);
    const [CloseBtnSrc, setCloseBtnSrc] = useState(x_close_btn_n);
    const [NextStepBtnSrc, setNextStepBtnSrc] = useState(next_step_btn_n);
    const [GotItBtnSrc, setGotItBtnSrc] = useState(got_it_btn_n);
    const [solutionSrc, setSolutionSrc] = useState(solution_n);

    const [questionContent, setQuestionContent] = useState<Document | null>(null);
    const [items, setItems] = useState<string[]>([]);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [feedback, setFeedback] = useState<(boolean | null)[]>([]);
    const [bgUrls, setBgUrls] = useState({ normal: '', selected: '' });
    const [dividerUrl, setDividerUrl] = useState('');
    const correctAnswerOrder = useRef<string[]>([]);
    const initialOptionOrder = useRef<string[]>([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [showClueModal, setShowClueModal] = useState(false);
    const [clueContent,
        setClueContent
    ] = useState('');
    const [isClueLoading,
        setIsClueLoading
    ] = useState(false);
    const [noOfClues, setNoOfClues] = useState(0);
    const [currentClueNo, setCurrentClueNo] = useState(0);
    const [clueSeen, setClueSeen] = useState(false);
    const [showPrcModal, setShowPrcModal] = useState(false);
    const [prcContent,
        setPrcContent
    ] = useState("");
    const [isPrcLoading,
        setIsPrcLoading
    ] = useState(false);
    const [prcSeen, setPrcSeen] = useState(false);
    const [principleList, setPrincipleList] = useState<string[]>([]);
    const [currentPrcIndex, setCurrentPrcIndex] = useState(0);

    const [showSolnModal, setShowSolnModal] = useState(false);
    const [isSolnLoading,
        setIsSolnLoading
    ] = useState(false);
    const [solnContent,
        setSolnContent
    ] = useState("");
    const [solutionSeen, setSolutionSeen] = useState<string | number>('N');
    const [currentSolnNo, setCurrentSolnNo] = useState(0);
  const [revealedSolnSteps, setRevealedSolnSteps] = useState<number[]>([]);
    useEffect(() => {
      setCurrentSolnNo(0);
      setRevealedSolnSteps([]);
    }, [currentQnMeta?.QnNo]);
    const [noOfSteps, setNoOfSteps] = useState(0);
    const [startTime, setStartTime] = useState<Date | null>(null);
    const isInAssessment = window.location.href.includes('Assessment');

    const handleNextStepBtnMouseOver = () => setNextStepBtnSrc(next_step_btn_o);
    const handleNextStepBtnMouseOut = () => setNextStepBtnSrc(next_step_btn_n);
    const handleGotItBtnMouseOver = () => setGotItBtnSrc(got_it_btn_o);
    const handleGotItBtnMouseOut = () => setGotItBtnSrc(got_it_btn_n);
    const handleCloseBtnMouseOver = () => setCloseBtnSrc(x_close_btn_o);
    const handleCloseBtnMouseOut = () => setCloseBtnSrc(x_close_btn_n);
    const handleBackMouseOver = () => setBackSrc(back_o);
    const handleBackMouseOut = () => setBackSrc(back_n);
    const handleBackMouseDown = () => setBackSrc(back_d);
    const handleBackMouseUp = () => setBackSrc(back_o);
    const handleNextMouseOver = () => setNextSrc(next_o);
    const handleNextMouseOut = () => setNextSrc(next_n);
    const handleNextMouseDown = () => setNextSrc(next_d);
    const handleNextMouseUp = () => setNextSrc(next_o);
    const handleOkMouseOver = () => setOkSrc(ok_o);
    const handleOkMouseOut = () => setOkSrc(ok_n);
    const handleOkMouseDown = () => setOkSrc(ok_d);
    const handleOkMouseUp = () => setOkSrc(ok_o);
    const handleSolutionMouseOver = () => setSolutionSrc(solution_o);
    const handleSolutionMouseOut = () => setSolutionSrc(solution_n);
    const handleSolutionMouseDown = () => setSolutionSrc(solution_d);


    const { isViewLesson, isAnswerMode, isSolutionMode, isPreview, guardSave, handleDoneClick } = useViewLessonPreview(previewMode);

        const handleSolnClick = useCallback(async (autoExpand = false) => {
        if (!currentQnMeta || !lessonMeta) return;

        setShowSolnModal(true);
        setIsSolnLoading(true);
        setSolnContent("");
        setNoOfSteps(0);

        const searchParams = new URLSearchParams(window.location.search);
        const folderParam = searchParams.get('folder');
        const countryParam = searchParams.get('country') || 'Australia';

        if (!folderParam) {
            showAlert("Could not determine the lesson folder.");
            setIsSolnLoading(false);
            setShowSolnModal(false);
            return;
        }

        const accessToken = localStorage.getItem('access_token');
        const headers: HeadersInit = { 'Content-Type': 'application/json' };
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        } else {
            console.warn("Access token not found in localStorage.");
        }

        const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

        try {
            const response = await fetch(`${apiUrl}solution/`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    folder: folderParam,
                    questionNo: currentQnMeta.QnNo,
                    country: countryParam,
                    autoExpand: autoExpand,
                }),
            });

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    showAlert("Authentication failed. Please log in again.");
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setSolnContent(data.solutionHtml || "");
            if (solutionSeen === 'N') {
                setSolutionSeen(1);
            }

        } catch (error) {
            console.error("Error fetching solution:", error);
            if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403")))) {
                showAlert("Failed to load the solution. Please try again.");
            }
            setShowSolnModal(false);
        } finally {
            setIsSolnLoading(false);
        }
    }, [currentQnMeta, lessonMeta, showAlert, solutionSeen]);
    
    useEffect(() => {
        setOkClicked(false);
        setItems([]);
        setSelectedIndex(null);
        setFeedback([]);
        setStartTime(new Date());
        setSolutionSeen('N');
        setClueSeen(false);
        setPrcSeen(false);
        if (lessonMeta?.qns) {
            setCurrentQnMeta(lessonMeta.qns[currentPage - 1]);
        }

        if (questionHtml) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(questionHtml, 'text/html');
            setQuestionContent(doc);

            const initialOrderEl = doc.getElementById('initial-order') as HTMLInputElement;
            const answerKeyEl = doc.getElementById('answer-key') as HTMLInputElement;
            const normalBgEl = doc.getElementById('normal-bg-url') as HTMLInputElement;
            const selectedBgEl = doc.getElementById('selected-bg-url') as HTMLInputElement;
            const dividerUrlEl = doc.getElementById('divider-bar-url') as HTMLInputElement;

            if (initialOrderEl && answerKeyEl) {
                const correctOrder = JSON.parse(answerKeyEl.value);
                correctAnswerOrder.current = correctOrder;

                // NEW — admin preview only (QNS-ANS / SOLUTION from sysadmin
                // EL_ViewLesson). LQns has no iframe bridge to bake a flag
                // into, so we just render the list pre-sorted into the
                // correct order and pre-mark every row as correct, then flip
                // the UI to "answered" exactly as a real correct OK-click
                // would — without saving anything. Real students (isPreview
                // false) fall through to the untouched original behavior.
                if (isPreview) {
                    setItems(correctOrder);
                    setFeedback(correctOrder.map(() => true));
                    setOkClicked(true);
                    if (isSolutionMode) {
                        handleSolnClick(true);
                    }
                } else {
                    const initialItems = JSON.parse(initialOrderEl.value) as string[];
                    initialOptionOrder.current = initialItems;
                    setItems(initialItems);
                }
            }
            if (normalBgEl && selectedBgEl) {
                setBgUrls({ normal: normalBgEl.value, selected: selectedBgEl.value });
            }
            if (dividerUrlEl) {
                setDividerUrl(dividerUrlEl.value);
            }
        }
    }, [currentPage, questionHtml, lessonMeta, isPreview, isSolutionMode, handleSolnClick]);

    const handleItemClick = (clickedIndex: number) => {
        if (okClicked) return;

        if (selectedIndex === clickedIndex) {
            setSelectedIndex(null);
        } else if (selectedIndex === null) {
            setSelectedIndex(clickedIndex);
        } else {
            const newItems = [...items];
            const itemToMove = newItems.splice(selectedIndex, 1)[0];
            newItems.splice(clickedIndex, 0, itemToMove);
            setItems(newItems);
            setSelectedIndex(null);
        }
    };

    const handleClueClick = useCallback(async () => {
        if (!currentQnMeta || !lessonMeta) return;

        setShowClueModal(true);
        setIsClueLoading(true);
        setClueContent("");
        setCurrentClueNo(0);
        setNoOfClues(0);

        const searchParams = new URLSearchParams(window.location.search);
        const folderParam = searchParams.get('folder');
        const countryParam = params.get('country') || 'Australia';
        const varValuesParam = currentQnMeta?.VarValues || "";

        if (!folderParam) {
            showAlert("Could not determine the lesson folder.");
            setIsClueLoading(false);
            setShowClueModal(false);
            return;
        }

        const accessToken = localStorage.getItem('access_token');
        const headers: HeadersInit = { 'Content-Type': 'application/json' };
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        } else {
            console.warn("Access token not found in localStorage.");
        }

        const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

        try {
            const response = await fetch(`${apiUrl}clue/`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    folder: folderParam,
                    questionNo: currentQnMeta.QnNo,
                    country: countryParam,
                    varValues: varValuesParam,
                }),
            });

            if (!response.ok) {
                if (response.status === 404) {
                    setClueContent("");
                } else {
                    if (response.status === 401 || response.status === 403) {
                        showAlert("Authentication failed. Please log in again.");
                    }
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
            } else {
                const data = await response.json();
                setClueContent(data.clueHtml || "");
                setClueSeen(true); // Mark clue as seen
            }

        } catch (error) {
            console.error("Error fetching clue:", error);
            if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403") || error.message.includes("status: 404")))) {
                showAlert("Failed to load the clue. Please try again.");
            }
            setClueContent("");
        } finally {
            setIsClueLoading(false);
        }
    }, [currentQnMeta, lessonMeta, showAlert, params]);



    const fetchPrincipleContent = async (principleId: string, folderParam: string, countryParam: string) => {
        const accessToken = localStorage.getItem('access_token');
        const headers: HeadersInit = { 'Content-Type': 'application/json' };
        if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

        const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

        const response = await fetch(`${apiUrl}principle/`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                folder: folderParam,
                questionNo: principleId,
                country: countryParam,
            }),
        });

        if (!response.ok) throw new Error("Failed");
        return await response.json();
    };

    const handlePrcClick = useCallback(async () => {
        if (!currentQnMeta || !lessonMeta) return;

        const prcString = currentQnMeta.PrincipleNos || "";
        const prcIds = prcString.replace(/"/g, "").split(',').filter((s: string) => s.trim() !== "");

        if (prcIds.length === 0) {
            if ((currentQnMeta.NoOfPrc || 0) > 0) {
                prcIds.push("1");
            } else {
                showAlert("No principles found for this question.");
                return;
            }
        }

        setShowPrcModal(true);
        setIsPrcLoading(true);
        setPrcContent("");
        setPrincipleList(prcIds);
        setCurrentPrcIndex(0);

        const searchParams = new URLSearchParams(window.location.search);
        const folderParam = searchParams.get('folder');
        const countryParam = params.get('country') || 'Australia';

        if (!folderParam) {
            showAlert("Could not determine the lesson folder.");
            setIsPrcLoading(false);
            setShowPrcModal(false);
            return;
        }

        try {
            const data = await fetchPrincipleContent(prcIds[0], folderParam, countryParam);
            setPrcContent(data.principleHtml || "");
            setPrcSeen(true);
        } catch (error) {
            console.error("Error fetching principle:", error);
            setPrcContent("");
        } finally {
            setIsPrcLoading(false);
        }
    }, [currentQnMeta, lessonMeta, showAlert, params]);

    useImperativeHandle(ref, () => ({
        getAnswer: () => {
            let allCorrect = true;
            items.forEach((item, index) => {
                if (item !== correctAnswerOrder.current[index]) {
                    allCorrect = false;
                }
            });

            const marks = allCorrect ? 1 : 0;
            const userAnswerString = items.join('|');

            return {
                marks,
                noOfOptions: items.length,
                enteredCorrectAnswer: allCorrect ? userAnswerString : "",
                enteredWrongAnswer: !allCorrect ? userAnswerString : "",
                enteredBlankAnswer: "",
                // Legacy EL_L stores the original option indexes in their
                // current (student-arranged) order, separated by ~.
                optOrder: (() => {
                    const available = [...initialOptionOrder.current];
                    return items.map(item => {
                        const index = available.indexOf(item);
                        if (index >= 0) available[index] = '';
                        return index;
                    }).filter(index => index >= 0).join('~');
                })(),
                scoringMethod: null
            };
        }
    }));

    const playRandomSound = useCallback(async (soundFiles: string[], folder: 'Correct' | 'Incorrect') => {
        const baseUrl = assetsBaseUrl;
        if (!soundFiles || soundFiles.length === 0) return;
        const fileName = soundFiles[Math.floor(Math.random() * soundFiles.length)];
        const audioUrl = `${baseUrl}Audio/Question/${folder}/${fileName}`;
        const audio = new Audio(audioUrl);
        try { await audio.play(); } catch (error) { console.error(`Error playing audio from ${audioUrl}:`, error); }
    }, [assetsBaseUrl]);

    const handleDbUpdate = useCallback(guardSave((payload: QuestionPerformancePayload) => {
        return saveQuestionPerformance(payload)
            .then((data) => {
                if (isCompleting && updateSessionPoints) {
                    updateSessionPoints(data.pointsEarned || 0);
                }
                return data;
            })
            .catch((error) => {
                console.error("Save Performance Error:", error);
                throw error;
            });
    }), [isCompleting, updateSessionPoints, guardSave]);

    const handleOkClick = useCallback(async (e: React.MouseEvent<any>) => {
        e.preventDefault();
        if (okClicked || isSubmitting) return;

        let allCorrect = true;
        const newFeedback = items.map((item, index) => {
            const isCorrect = item === correctAnswerOrder.current[index];
            if (!isCorrect) allCorrect = false;
            return isCorrect;
        });

        const marks = allCorrect ? 1 : 0;
        const userAnswerString = items.join('|');

        const questionAnswerTime = startTime ? Math.floor((new Date().getTime() - startTime.getTime()) / 1000) : 0;
        const schoolCode = sessionStorage.getItem('SchoolCode') || '';
        const familyCode = sessionStorage.getItem('FamilyCode') || '';
        const login = sessionStorage.getItem('Login') || '';
        const chapterCode = sessionStorage.getItem('ChapterCode') || '';
        const unitCode = sessionStorage.getItem('UnitCode') || '';

        const payload: QuestionPerformancePayload = {
            schoolCode,
            familyCode,
            login,
            dicCode: sessionStorage.getItem('SelectedDICFile') || '',
            lsnTestCode: sessionStorage.getItem('LsnTestCode') || '',
            sessionId: sessionId || 1,
            qnNo: currentQnMeta?.QnNo,
            subNo: 0,
            qnType: currentQnMeta?.QnType,
            marks: marks,
            noOfOptions: items.length,
            optOrder: (() => {
                const available = [...initialOptionOrder.current];
                return items.map(item => {
                    const index = available.indexOf(item);
                    if (index >= 0) available[index] = '';
                    return index;
                }).filter(index => index >= 0).join('~');
            })(),
            enteredCorrectAnswer: allCorrect ? userAnswerString : "",
            enteredWrongAnswer: !allCorrect ? userAnswerString : "",
            enteredBlankAnswer: "",
            solutionSeen: (typeof solutionSeen === 'number' && solutionSeen > 0) || solutionSeen === 'Y' ? 'Y' : 'N',
            clueSeen: clueSeen,
            principleSeen: prcSeen,
            questionLoadTime: 0,
            questionAnswerTime: questionAnswerTime,
            lastQnInd: currentQnMeta?.LastQnInd || currentPage,
            nextQnData: buildNextQuestionData(lessonMeta?.qns, currentPage),
            dbgShuffledQnsOrder: buildShuffledQuestionsOrder(lessonMeta?.qns),
            allQuestionsCompleted: isCompleting ? 'True' : 'False',
            chapterCode: chapterCode,
            unitCode: unitCode,
            hwid: hwid,
            subject: subject
        };

        // --- 3. HYBRID SUBMISSION LOGIC ---
        const isLastQuestion = currentPage === totalPages;

        if (isLastQuestion) {
            // BLOCKING: Show Loading, Wait for DB
            setIsSubmitting(true);
            try {
                await handleDbUpdate(payload);
            } catch (e) {
                console.error("Final submit failed", e);
                showAlert("Error saving progress. Please try again.");
                setIsSubmitting(false);
                return;
            }
            setIsSubmitting(false);
        } else {
            // BACKGROUND: Fire and forget
            handleDbUpdate(payload).catch(e => console.error("Background save failed", e));
        }

        // --- 4. UI FEEDBACK ---
        setFeedback(newFeedback);

        if (allCorrect) {
            playRandomSound(correctAudio, 'Correct');
        } else {
            playRandomSound(incorrectAudio, 'Incorrect');

            if (currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0) {
                handleSolnClick(true);
            }
        }

        setOkClicked(true);
    }, [items, handleSolnClick, okClicked, isSubmitting, correctAudio, incorrectAudio, playRandomSound, startTime, lessonMeta, currentQnMeta, currentPage, totalPages, sessionId, isCompleting, updateSessionPoints, handleDbUpdate, hwid, subject, clueSeen, prcSeen, solutionSeen, showAlert]);

    const renderMainContent = () => {
        if (!questionContent) return <Loading />;
        const qnTable = questionContent.querySelector('table[name="TableQn"]');
        return qnTable ? <div className="l-qns-main" dangerouslySetInnerHTML={{ __html: qnTable.outerHTML }} /> : null;
    };

    const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";
    const WRONG_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsWrong.GIF";

    const handleBack = () => {
        const calledFrom = params.get("calledFrom");

        // console.log("calledFrom:", calledFrom);
        if (calledFrom) {
            const redirectPath = decodeURIComponent(calledFrom);
            window.location.href = redirectPath;
        }
        else if (window.history.length > 1) {
            window.history.back();
        }
    };

    return (
        <>
            <style>{lQnsStyles}</style>
            {!isInAssessment && (
                <tr id="trQnButtons">
                    <td className="QnPanelT">
                        <table id="tabQnNav" className="QnPanel2T" style={{ height: "50px" }}>
                            <tbody>
                                <tr id="trQnOK" className="trQnOKT">
                                    <td id="QnPanelIdT" className="QnPanel">&nbsp;</td>
                                    <td id="QnPanelId2T" className="QnPanel">
                                        <div
                                            onClick={!okClicked ? handleBack : undefined}
                                            style={{ display: okClicked ? 'none' : 'block', cursor: 'pointer' }}
                                        >
                                            <div id="imgbtnBack" className="imgbtnBackT">
                                                <img
                                                    src={backSrc}
                                                    alt="Back"
                                                    onMouseOver={handleBackMouseOver}
                                                    onMouseOut={handleBackMouseOut}
                                                    onMouseDown={handleBackMouseDown}
                                                    onMouseUp={handleBackMouseUp}
                                                    className="imgbtnBack2T"
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td id="QnPanelId3T" className="QnPanel">
                                        <input
                                            type="image"
                                            id="imgPrc"
                                            src={principle_n}
                                            className="imgPrcT"
                                            alt="Principle"
                                            style={{ display: !okClicked && currentQnMeta?.NoOfPrc && currentQnMeta.NoOfPrc > 0 ? 'inline-block' : 'none' }}
                                            onClick={(e) => { e.preventDefault(); handlePrcClick(); }}
                                        />
                                    </td>
                                    <td id="QnPanelId4T" className="QnPanel">
                                        <input
                                            type="image"
                                            id="imgClue"
                                            src={clue_n}
                                            className="imgClueT"
                                            alt="Clue"
                                            style={{ display: !okClicked && Number(currentQnMeta?.NoOfClues || 0) > 0 ? 'inline-block' : 'none' }}
                                            onClick={(e) => { e.preventDefault(); handleClueClick(); }}
                                        />
                                    </td>
                                    <td id="QnPanelId5T" className="QnPanel">
                                        <input
                                            type="image" id="imgSoln" src={solutionSrc} className="imgSolnT" alt="Solution"
                                            style={{ display: currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0 ? 'inline-block' : 'none' }}
                                            onClick={(e) => { e.preventDefault(); handleSolnClick(false); }}
                                            onMouseOver={handleSolutionMouseOver}
                                            onMouseOut={handleSolutionMouseOut}
                                            onMouseDown={handleSolutionMouseDown}
                                        />
                                    </td>
                                    <td id="QnPanelId5T" className="QnPanel">
                                        <a
                                            href={`/STUDENT/Tutorials/Tutorial?id=${folderParam}&name=${encodeURIComponent(lessonName ?? '')}&folder=${encodeURIComponent(diccode ?? '')}&calledFrom=${encodeURIComponent(calledFrom ?? '')}&sessionId=${sessionId}&currentPage=${currentPage}`}
                                            id="imgbtnTut"
                                            className="imgbtnTutT"
                                            style={{ display: okClicked ? 'none' : 'inline-block' }}
                                        >
                                            <img src={tutorials_n} alt="Tutorial" id="imgbtnTut2T" />
                                        </a>
                                    </td>
                                    <td id="QnPanelId6T" className="QnPanel">
                                        {isSubmitting ? (
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                                                <Loading />
                                            </div>
                                        ) : (
                                            okClicked ? (
                                                currentPage === totalPages ? (
                                                    <img
                                                        src={doneSrc}
                                                        alt="Done"
                                                        style={{ verticalAlign: 'middle' }}
                                                        onClick={() => handleDoneClick(() => {
                                                            const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
                                                            const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
                                                            const calledFrom = params.get("calledFrom") || "";
                                                            navigate(`/STUDENT/Tutorials/Result?DicCode=${dicCode}&LsnTestCode=${lsnTestCode}&SessionID=${sessionId}&source=lesson&complete=1` + (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : ""));
                                                        })}
                                                        onMouseOver={() => setDoneSrc(done_o)}
                                                        onMouseOut={() => setDoneSrc(done_n)}
                                                    />
                                                ) : (
                                                    <img src={nextSrc} alt="Next" onClick={goToNextPage} onMouseOver={handleNextMouseOver} onMouseOut={handleNextMouseOut}
                                                        style={{ display: 'inline-block', cursor: 'pointer', marginTop: '3px' }} />
                                                )
                                            ) : (
                                                <div onClick={handleOkClick} onMouseOver={handleOkMouseOver} onMouseOut={handleOkMouseOut}
                                                    style={{ display: 'inline-block', cursor: 'pointer' }}>
                                                    <img src={okSrc} alt="OK" style={{ marginTop: '3px' }} />
                                                </div>
                                            )
                                        )}
                                    </td>
                                    <td id="QnPanelId7" className="QnPanel">&nbsp;</td>
                                </tr>
                                <tr id="trQnNext" className="trQnNextT">
                                    <td id="tdBN1" className="QnPanel">&nbsp;</td>
                                    <td id="tdAnsMsg" className="QnPanel">&nbsp;</td>
                                    <td id="tdShowCA" className="QnPanel">&nbsp;</td>
                                    <td id="tdAnsSoln" className="QnPanel">
                                        <img id="imgSolnAfterAnswering" src={solution_n} alt="Solution" />
                                    </td>
                                    <td id="tdQnNext" className="QnPanel">
                                        {okClicked ? (
                                            <input type="image" id="imgNextQuestion" src={nextSrc} alt="Next" onClick={goToNextPage}
                                                onMouseOver={handleNextMouseOver} onMouseOut={handleNextMouseOut} style={{ display: okClicked ? 'inline-block' : 'none' }} />
                                        ) : (
                                            <img id="imgOK" src={okSrc} alt="OK" onClick={handleOkClick} onMouseOver={handleOkMouseOver}
                                                onMouseOut={handleOkMouseOut} className="imgOKT" style={{ display: okClicked ? 'none' : 'inline-block' }} />
                                        )}
                                    </td>
                                    <td id="tdBN" className="QnPanel">&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}

            {questionHtml ? (
                <tr id="triFrame">
                    <td id="tdFrameQnT" style={{ height: '100%', padding: 0 }}>
                        <div style={{ height: 'calc(95vh - 50px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
                            <div className="l-qns-container">
                                {renderMainContent()}
                                <div className="l-qns-divider" style={{ backgroundImage: `url(${dividerUrl})` }}></div>
                                <div className="l-qns-options-panel">
                                    <div className="l-qns-options-header">Your Options:</div>
                                    <div>
                                        {items.map((item, index) => (
                                            <div
                                                key={index}
                                                className="l-qns-option-item"
                                                style={{ backgroundImage: `url(${selectedIndex === index ? bgUrls.selected : bgUrls.normal})` }}
                                                onClick={() => handleItemClick(index)}
                                            >
                                                <div className="feedback-box">
                                                    {feedback.length > 0 && (
                                                        <img
                                                            src={feedback[index] ? CORRECT_URL : WRONG_URL}
                                                            alt={feedback[index] ? 'Correct' : 'Incorrect'}
                                                            style={{ height: '20px' }}
                                                        />
                                                    )}
                                                </div>
                                                <span className="item-text">{item}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            ) : (
                <tr>
                    <td><Loading /></td>
                </tr>
            )}

            {showClueModal && (
                <div className="modal-overlay" onClick={() => setShowClueModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <span>Clue</span>
                            <img src={CloseBtnSrc} alt="Close" onClick={() => setShowClueModal(false)} onMouseOver={handleCloseBtnMouseOver}
                                onMouseOut={handleCloseBtnMouseOut} style={{ cursor: 'pointer' }} />
                        </div>
                        <div className="modal-body">
                            {isClueLoading ? <Loading /> : (
                                <iframe
                                    id="iFrameClue"
                                    ref={clueIframeRef}
                                    title="Clue"
                                    srcDoc={clueContent}
                                    style={{ width: '100%', border: 'none', minHeight: '80px' }}
                                    onLoad={() => {
                                        // console.log("Clue iframe onLoad event fired.");
                                        const iframe = clueIframeRef.current;
                                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) { return; }
                                        try {
                                            const divShows = iframe.contentDocument.querySelectorAll("[id^='divShow']");
                                            divShows.forEach(div => {
                                                (div as HTMLElement).style.padding = "20px";
                                            });
                                            const cluesInput = iframe.contentDocument.getElementById('NoOfClues') as HTMLInputElement;
                                            const totalClues = parseInt(cluesInput?.value || '0', 10);
                                            setNoOfClues(totalClues);
                                            const clueDivs = iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]');
                                            clueDivs.forEach((div, index) => {
                                                div.style.display = index === 0 ? 'block' : 'none';
                                            });
                                            const firstClueDiv = iframe.contentDocument.getElementById('divShow1');
                                            if (firstClueDiv) {
                                                const newHeight = firstClueDiv.scrollHeight;
                                                iframe.style.height = `${Math.min(newHeight, 300)}px`;
                                            } else if (totalClues === 0) {
                                                iframe.style.height = '50px';
                                            }
                                        } catch (e) { console.error("Error inside clue iframe onLoad:", e); }
                                    }}
                                />
                            )}
                        </div>
                        <div className="modal-footer">
                            {!isClueLoading && noOfClues > 1 && currentClueNo < noOfClues - 1 && (
                                <img
                                    id="btnClueNext"
                                    src={NextStepBtnSrc}
                                    alt="Next Clue"
                                    onClick={() => {
                                        const nextClue = currentClueNo + 1;
                                        const iframe = clueIframeRef.current;
                                        if (iframe?.contentDocument) {
                                            iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]').forEach((div, index) => {
                                                div.style.display = index === nextClue ? 'block' : 'none';
                                            });
                                            setCurrentClueNo(nextClue);
                                            const nextClueDiv = iframe.contentDocument.getElementById(`divShow${nextClue + 1}`);
                                            if (nextClueDiv) {
                                                const newHeight = nextClueDiv.scrollHeight + 20;
                                                iframe.style.height = `${Math.min(newHeight, 300)}px`;
                                            }
                                        }
                                    }}
                                    onMouseOver={handleNextStepBtnMouseOver}
                                    onMouseOut={handleNextStepBtnMouseOut}
                                    style={{ cursor: 'pointer' }}
                                />
                            )}
                            {!isClueLoading && (noOfClues <= 1 || currentClueNo === noOfClues - 1) && (
                                <img
                                    id="btnClueGotIt"
                                    src={GotItBtnSrc}
                                    alt="Got It"
                                    onClick={() => setShowClueModal(false)}
                                    onMouseOver={handleGotItBtnMouseOver}
                                    onMouseOut={handleGotItBtnMouseOut}
                                    style={{ cursor: 'pointer', display: isClueLoading ? 'none' : 'inline-block' }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showPrcModal && (
                <>
                    <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowPrcModal(false)}></div>

                    <div id="divPCS" style={{ display: 'block' }} className="principle">

                        {/* Header */}
                        <table id="tblTitlePCS" className="principle" cellSpacing="0" cellPadding="0" width="100%">
                            <tbody>
                                <tr>
                                    <td id="tdPCSTitle1" style={{ paddingLeft: '15px', color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
                                        Principle {principleList.length > 1 ? ` ${currentPrcIndex + 1} of ${principleList.length}` : ''}
                                    </td>
                                    <td id="tdPCSClose" align="right" valign="top">
                                        <img
                                            id="imgPCSClose"
                                            src={CloseBtnSrc}
                                            alt="Close"
                                            onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                                            onMouseOver={handleCloseBtnMouseOver}
                                            onMouseOut={handleCloseBtnMouseOut}
                                            style={{ cursor: 'pointer', padding: '5px', width: '40px', height: '40px', marginRight: '30px' }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Body */}
                        <div id="divFramePCS">
                            {isPrcLoading ? <Loading /> : (
                                <iframe
                                    id="iFramePrc"
                                    ref={prcIframeRef}
                                    title="Prc"
                                    srcDoc={prcContent}
                                    style={{ width: '100%', border: 'none', overflow: 'hidden', display: 'block' }} // 2. Set overflow hidden initially
                                    onLoad={() => {
                                        const iframe = prcIframeRef.current;
                                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;

                                        setTimeout(() => {
                                            if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                                            const contentHeight = iframe.contentDocument.body.scrollHeight + 20;

                                            const divPCS = document.getElementById('divPCS') as HTMLElement;
                                            const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                            const navTable = document.getElementById('tblNavPCS') as HTMLElement;
                                            if (divPCS && titleTable && navTable) {
                                                const maxModalHeight = window.innerHeight * 0.8;
                                                const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;
                                                if (contentHeight > maxIframeHeight) {

                                                    iframe.style.height = `${maxIframeHeight}px`;
                                                    iframe.style.overflowY = 'auto';
                                                } else {

                                                    iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                                                    iframe.style.overflowY = 'hidden';
                                                }
                                            } else {
                                                iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                                            }
                                        }, 50);
                                    }}
                                />
                            )}
                        </div>

                        {/* Footer / Navigation */}
                        <table id="tblNavPCS" className="principle" cellSpacing="0" cellPadding="0" width="100%" style={{ height: '50px', fontSize: "15px" }}>
                            <tbody>
                                <tr style={{ backgroundColor: '#F2F2F2' }}>
                                    {/* Previous Button */}
                                    <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                                        {currentPrcIndex > 0 && (
                                            <input
                                                type='button'
                                                value='PREVIOUS'
                                                onClick={() => {
                                                    const prevIndex = currentPrcIndex - 1;
                                                    setCurrentPrcIndex(prevIndex);
                                                    const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                                                    const countryParam = params.get('country') || 'Australia';
                                                    fetchPrincipleContent(principleList[prevIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                                                }}
                                                style={{
                                                    fontWeight: 'bold',
                                                    color: 'White',
                                                    fontSize: '12pt',
                                                    borderStyle: 'none',
                                                    backgroundColor: 'maroon',
                                                    cursor: 'pointer',
                                                    padding: '5px 10px'
                                                }}
                                            />
                                        )}
                                    </td>

                                    <td style={{ width: '34%' }}>&nbsp;</td>

                                    {/* Next / Got It Button */}
                                    <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                                        {currentPrcIndex < principleList.length - 1 ? (
                                            <img
                                                src={NextStepBtnSrc}
                                                alt="Next"
                                                onClick={() => {
                                                    const nextIndex = currentPrcIndex + 1;
                                                    setCurrentPrcIndex(nextIndex);
                                                    const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                                                    const countryParam = params.get('country') || 'Australia';
                                                    fetchPrincipleContent(principleList[nextIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                                                }}
                                                onMouseOver={handleNextStepBtnMouseOver}
                                                onMouseOut={handleNextStepBtnMouseOut}
                                                style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                                            />
                                        ) : (
                                            <img
                                                src={GotItBtnSrc}
                                                id="imgGotIt"
                                                alt="Got It"
                                                onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                                                onMouseOver={handleGotItBtnMouseOver}
                                                onMouseOut={handleGotItBtnMouseOut}
                                                style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                                            />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {showSolnModal && (
                <>
                    <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => {
                        setShowSolnModal(false);
                    }}></div>

                    <div id="divPCS" style={{ display: 'block', position: 'fixed', bottom: '0', width: '100%', zIndex: 10000 }}>
                        <table id="tblTitlePCS" className="solution" cellSpacing="0" cellPadding="0" width="100%">
                            <tbody>
                                <tr>
                                    <td id="tdPCSTitle1">Step by step solution</td>
                                    <td id="tdPCSClose" align="right" valign="top">
                    <button
                      type="button"
                      aria-label="Close solution"
                      onClick={() => setShowSolnModal(false)}
                      style={{ width: '30px', height: '30px', margin: '5px 15px 5px 0', padding: 0, border: 0, borderRadius: 0, backgroundColor: '#ff6500', color: '#fff', fontSize: '18px', lineHeight: '30px', textAlign: 'center', cursor: 'pointer' }}
                    >
                      ×
                    </button>
                  </td>
                                </tr>
                            </tbody>
                        </table>

                        <div id="divFramePCS">
                            {isSolnLoading ? <Loading /> : (
                                <iframe
                                    id="iFrameSolution"
                                    ref={solnIframeRef}
                                    title="Solution"
                                    srcDoc={solnContent}
                                    style={{ width: '100%', border: 'none', minHeight: '50px' }}
                                    onLoad={() => {
                                        const iframe = solnIframeRef.current;
                                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) {
                                            console.error("Iframe document or window not ready in onLoad.");
                                            return;
                                        }
                                        try {
                                            const iframeDoc = iframe.contentDocument;
                                            const stepsInput = iframeDoc.getElementById('NoOfSteps') as HTMLInputElement;
                                            const totalSteps = parseInt(stepsInput?.value || '0', 10);
                                            setNoOfSteps(totalSteps);

                                            const isAutoExpanded = iframeDoc.getElementById('IsAutoExpanded');

                                            const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                                            stepRows.forEach((step) => {
                                              step.querySelectorAll<HTMLElement>(':scope > td').forEach((cell) => {
                                                if (!cell.style.color && !cell.hasAttribute('color')) cell.style.color = 'black';
                                              });
                                            });
                                            let firstStepHeight = 150;

                                            stepRows.forEach((step, index) => {
                        const rhsCell = step.querySelector<HTMLElement>(':scope > td:last-of-type');
                        rhsCell?.style.setProperty('text-align', 'left', 'important');
                        rhsCell?.style.setProperty('padding-left', '12px', 'important');
                                                if (index <= currentSolnNo || isAutoExpanded) {
                                                    step.style.display = 'table-row';
                                                } else {
                                                    step.style.display = 'none';
                                                }
                                            });

                                            if (totalSteps === 0) {
                                                iframe.style.height = '50px';
                                            }

                                            setTimeout(() => {
                                                if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                                                const totalRequiredHeight = iframe.contentDocument.body.scrollHeight + 5;

                                                const divPCS = document.getElementById('divPCS') as HTMLElement;
                                                const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                                const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                                                if (!divPCS || !titleTable || !navTable) return;

                                                const maxModalHeight = window.innerHeight * 0.45;
                                                const chromeHeight = titleTable.offsetHeight + navTable.offsetHeight;
                                                const maxAllowedIframeHeight = maxModalHeight - chromeHeight;

                                                if (totalRequiredHeight > maxAllowedIframeHeight) {
                                                    iframe.style.height = `${maxAllowedIframeHeight}px`;
                                                    iframe.style.overflowY = 'auto';
                                                } else {
                                                    iframe.style.height = `${totalRequiredHeight}px`;
                                                    iframe.style.overflowY = 'hidden';
                                                }

                                                iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);

                                            }, 50);

                                            iframeDoc.querySelectorAll<HTMLImageElement>('img[id^="KsdImg"]').forEach(img => {
                        const index = img.id.substring(6);
                        const ksdDiv = iframeDoc.getElementById(`KsdDiv${index}`);
                        const content = ksdDiv?.getAttribute('data-ksd-content');
                        const wasPreviouslyRevealed = revealedSolnSteps.includes(Number(index));
                        const showCell = img.closest('td');
                        showCell?.style.setProperty('text-align', 'left', 'important');
                        showCell?.style.setProperty('padding-left', '12px', 'important');
                        const answerCell = ksdDiv?.closest('td') as HTMLTableCellElement | null;

                        const revealAnswer = () => {
                          if (!content || !showCell || !answerCell) return;
                          showCell.remove();
                          answerCell.colSpan = 2;
                          answerCell.innerHTML = content;
                          answerCell.style.setProperty('width', '50%', 'important');
                          answerCell.style.setProperty('max-width', 'none', 'important');
                          answerCell.style.setProperty('vertical-align', 'middle', 'important');
                          answerCell.style.setProperty('text-align', 'left', 'important');
                          answerCell.style.setProperty('padding-left', '12px', 'important');
                          answerCell.querySelectorAll<HTMLElement>('td').forEach(cell => {
                            cell.style.setProperty('text-align', 'left', 'important');
                            cell.style.setProperty('padding-left', '12px', 'important');
                          });
                        };

                        if (content && answerCell && wasPreviouslyRevealed) {
                          revealAnswer();
                          return;
                        }

                        img.onclick = () => {
                          if (img.getAttribute('alt') === '1') {
                            revealAnswer();
                            setRevealedSolnSteps(previous => previous.includes(Number(index)) ? previous : [...previous, Number(index)]);
                          }
                        };
                      });

                                        } catch (e) {
                                            console.error("Error inside solution iframe onLoad:", e);
                                        }
                                    }}
                                />
                            )}
                        </div>

                        <table id="tblNavPCS" className="solution" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
                            <tbody>
                                <tr>
                                    <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                                    </td>

                                    <td style={{ width: '34%' }}>
                                        &nbsp;
                                    </td>

                                    <td align="right" style={{ width: '33%', paddingRight: '15px' }}>

                                        {!isSolnLoading && noOfSteps > 0 && currentSolnNo < noOfSteps - 1 && (
                                            <img
                                                id="btnPCSNext"
                                                src={NextStepBtnSrc}
                                                alt="Next Step"
                                                onClick={() => {
                                                    const nextStep = currentSolnNo + 1;
                                                    const iframe = solnIframeRef.current;

                                                    if (iframe?.contentDocument?.body) {
                                                        const iframeDoc = iframe.contentDocument;

                                                        const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                                                        if (nextStep >= stepRows.length) return;

                                                        const nextStepElement = stepRows[nextStep];
                                                        nextStepElement.style.display = 'table-row';

                                                        setTimeout(() => {
                                                            if (!iframe.contentDocument) return;

                                                            const currentIframeHeight = iframe.offsetHeight;
                                                            const newStepHeight = nextStepElement.scrollHeight;

                                                            const divPCS = document.getElementById('divPCS') as HTMLElement;
                                                            const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                                            const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                                                            if (!divPCS || !titleTable || !navTable) return;

                                                            const maxModalHeight = window.innerHeight * 0.6;
                                                            const currentModalHeight = divPCS.offsetHeight;

                                                            if (currentModalHeight >= maxModalHeight) {
                                                                iframe.style.overflowY = 'auto';
                                                            } else {
                                                                const newIframeHeight = currentIframeHeight + newStepHeight;

                                                                const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;

                                                                if (newIframeHeight > maxIframeHeight) {
                                                                    iframe.style.height = `${maxIframeHeight}px`;
                                                                    iframe.style.overflowY = 'auto';
                                                                } else {
                                                                    iframe.style.height = `${newIframeHeight}px`;
                                                                }
                                                            }

                                                            iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);

                                                        });

                                                        setCurrentSolnNo(nextStep);
                                                        if (solutionSeen !== 'Y') {
                                                            setSolutionSeen(nextStep + 1);
                                                        }
                                                    }
                                                }}
                                                onMouseOver={handleNextStepBtnMouseOver}
                                                onMouseOut={handleNextStepBtnMouseOut}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        )}

                                        {!isSolnLoading && (noOfSteps === 0 || currentSolnNo === noOfSteps - 1) && (
                                            <img
                                                id="btnPCSClose"
                                                src={GotItBtnSrc}
                                                alt="Got It"
                                                onClick={() => {
                                                    setShowSolnModal(false);
                                                    setSolutionSeen('Y');
                                                }}
                                                onMouseOver={handleGotItBtnMouseOver}
                                                onMouseOut={handleGotItBtnMouseOut}
                                                style={{ cursor: 'pointer', display: isSolnLoading ? 'none' : 'inline-block' }}
                                            />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </>
    );
};

export default forwardRef(LQns);
